<template>
  <div class="list-split-line" :style="lineStyle"></div>
</template>
<script>
export default {
  name: "ListSplitLine",
  props: {
    lineStyle: {
      type: Object,
      default: function() {
        return {};
      }
    }
  }
};
</script>

<style lang="less" scoped>
.list-split-line {
  height: 0.06rem;
  background-color: #1e212d;
}
</style>